function marketplace() {
	var p = $(".price").text().split("        ")[0].replace("R$ ", "").replace(",", ".").trim();
	var e = $(".price--highlight").text().split("        ")[0].replace("R$ ", "").replace(",", ".").trim();
	var t = $(".price--compare").text().replace("R$ ", " ").replace(",", ".");
	var o = (100 * (t - e) / t).toFixed(2).split(".")[0];
    
    var n = "R$ " + (n = (n = 1 * ((p = parseFloat(p)) + 0) / 1).toFixed(2).replace(".", ","));
	var a = "R$ " + (a = (a = 1.0676 * ((p = parseFloat(p)) + 0) / 2).toFixed(2).replace(".", ","));
	var b = "R$ " + (b = (b = 1.0844 * ((p = parseFloat(p)) + 0) / 3).toFixed(2).replace(".", ","));
	var c = "R$ " + (c = (c = 1.1023 * ((p = parseFloat(p)) + 0) / 4).toFixed(2).replace(".", ","));
	var d = "R$ " + (d = (d = 1.1193 * ((p = parseFloat(p)) + 0) / 5).toFixed(2).replace(".", ","));
	var f = "R$ " + (f = (f = 1.1358 * ((p = parseFloat(p)) + 0) / 6).toFixed(2).replace(".", ","));
	var g = "R$ " + (g = (g = 1.1501 * ((p = parseFloat(p)) + 0) / 7).toFixed(2).replace(".", ","));
	var h = "R$ " + (h = (h = 1.1690 * ((p = parseFloat(p)) + 0) / 8).toFixed(2).replace(".", ","));
	var i = "R$ " + (i = (i = 1.1886 * ((p = parseFloat(p)) + 0) / 9).toFixed(2).replace(".", ","));
	var j = "R$ " + (j = (j = 1.2007 * ((p = parseFloat(p)) + 0) / 10).toFixed(2).replace(".", ","));
	var k = "R$ " + (k = (k = 1.2192 * ((p = parseFloat(p)) + 0) / 11).toFixed(2).replace(".", ","));
	var r = "R$ " + (r = (r = 1.2375 * ((p = parseFloat(p)) + 0) / 12).toFixed(2).replace(".", ","));

  
	$(".balinha_de_uva_nhamiiiiii").html(`<i style="font-size:14px;" class="far fa-credit-card"></i> <span>em até <b>12x</b> de <strong>` + r + `</strong></span>`)
}
window.matchMedia("(max-width: 768px)").matches && (window.onscroll = function() {
	var e = document.documentElement.scrollTop || document.body.scrollTop,
		t = document.getElementById("scrollToTop");
	t && (t.style.display = e > 1200 ? "block" : "none")
}), $(".block-swatch__radio, .variant-swatch__radio, .select-wrapper").change((function() {
	setTimeout((function() {
		marketplace()
	}), 0)
})), $(document).ready((function() {
	var e = $(".qtyplus");
	var t = $(".qtyminus");
	var a = $(".qty");
	e.click((function() {
		a.val(parseInt(a.val()) + 0).trigger("input")
	})), t.click((function() {
		a.val(Math.max(parseInt(a.val()) - 0, 1)).trigger("input")
	}))
}));